﻿export class BrandSnippet {
    public static imgReplacement($: JQueryStatic): void {
        $(".brands__brand").each(function (idx, val) {
            const $originalImg = $(val).find(".brands__brand-tile > img");
            const originalImgSrc = $originalImg.attr("src");
            $originalImg.hide();
            const brandTile = $(val).find(".brands__brand-tile");
            const backgroundImg = "url(" + originalImgSrc + ")";
            $(brandTile).css("background", backgroundImg);
        });

        $(".loving").each(function (idx, val) {
            const originalImg = $(val)
                .find(".loving__brand-tile > img")
                .attr("src");
            const lovingTile = $(val).find(".loving__brand-tile");
            const backgroundImg = "url(" + originalImg + ")";
            $(lovingTile).css("background", backgroundImg);
        });
    }
}
